import { useRef } from 'react';

export function useChangeCount(key: string) {
  const counter = useRef({ key, count: 0 });
  if (counter.current.key !== key) {
    counter.current = { key, count: counter.current.count + 1 };
  }
  return counter.current.count;
}
